import type { ApiClient, Appointment } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
import { appointment_status } from "@/models/appointment.model";

export const CANCELLABLE_STATUSES: readonly appointment_status[] = [
  appointment_status.pending,
  appointment_status.assigned,
  appointment_status.accepted,
  appointment_status.rescheduled,
];

export const isCancellable = (status: appointment_status): boolean => CANCELLABLE_STATUSES.includes(status);

export const NO_CANCELLATION_REASON_GIVEN = "No reason provided";

export const cancellationReasonFrom = (requested: unknown): string | undefined =>
  typeof requested === "string" && requested !== NO_CANCELLATION_REASON_GIVEN ? requested : undefined;

export const NOT_CANCELLABLE_REASON = "Only an appointment whose work has not started can be cancelled.";

type CancellationApi = Pick<ApiClient["appointments"], "cancel">;

export type CancellationRequest = { reason?: string; actingOrganization: uuid | null };

export function createAppointmentCancellation(api: CancellationApi) {
  return function cancel(id: uuid, { reason, actingOrganization }: CancellationRequest): Promise<Appointment> {
    const given = reason?.trim();
    return api.cancel(id, { ...(given ? { reason: given } : {}), ...(actingOrganization ? { actingOrganization } : {}) });
  };
}
